import React from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  NumberInput,
  ReferenceInput,
  SelectInput,
  DateInput,
  required,
  useNotify,
  useRedirect,

} from "react-admin";
import * as apiClient from "../../apiClient";
import { FormToolbar } from "../../common/FormToolbar";

export const EmployeeLeaveEdit = (props) => {
  const notify = useNotify();
  const redirect = useRedirect();

  const handleSubmit = (formdata) => {
    let userId: any
    userId = localStorage.getItem("userId");
    if (userId) {
      userId = parseInt(userId);
    }
    formdata.modifyBy = userId;
    formdata.modifyDate = new Date();
    formdata.approvedFromDate = formdata.fromDate
    formdata.approvedToDate = formdata.toDate
    formdata.totalApprovedDays=formdata.totalDays
    if (new Date(formdata.fromDate) > new Date(formdata.toDate)) {
      notify("To date cannot be less than from date", "warning")
      return;
    }
    apiClient.updateleave(formdata).then(res => {
      notify("Leave is updated")
      redirect("/employee-apply-leaves");
    }).catch(err => {
      console.log(err);
    });
  }
  return (
    <Edit title="Leave Edit" {...props}>
      <SimpleForm onSubmit={handleSubmit} redirect="list" toolbar={<FormToolbar label="Save" onSave={handleSubmit} onClose={props.onClose} onCancel={props.onCancel} />} variant="outlined" >
        <ReferenceInput label="Leave Type" source="leaveTypeId" reference="leave-types" fullWidth={true} validate={[required()]} >
          <SelectInput optionText="name" />
        </ReferenceInput>
        <DateInput variant="outlined" label="From Date" source="fromDate" fullWidth={true} validate={[required()]} />
        <DateInput variant="outlined" label="To Date" source="toDate" fullWidth={true} validate={[required()]} />
        <NumberInput variant="outlined" label="Total Days" source="totalDays" fullWidth={true} validate={[required()]} />
        <TextInput source="remarks" label='Remarks' fullWidth={true} />   
      </SimpleForm>
    </Edit>
  );
};
